const faq = [
  {
    question: 'Can I try creating an animation before I sign up?',
    answer:
      'Sure! Click the "Start Creating" button in the upper-right corner of the screen and get started as a guest user. ' +
      "You'll be able to create and publish one project to see if Animatron is right for you."
  },
  {
    question: 'Why is Animatron free?',
    answer:
      "We want to offer everyone the ability to create high-quality, mobile-friendly web animations. Once you've " +
      "seen the value that animation brings you, we hope that you'll upgrade to a paid plan to create more projects and " +
      'access advanced features.'
  },
  {
    question: 'Will I ever have to pay?',
    answer:
      'Use of the Animatron Studio Editor will always be free. If you want access to advanced features and export options, ' +
      'you can move to one of our <a href="/studio/pricing" title="Pricing">paid plans</a>.'
  },
  {
    question: 'Can I sign up with Facebook or Google?',
    answer:
      'Yes, just click the Facebook or Google button above the Sign up with Email button. We will never spam or post anything to your social account, promise.'
  },
  {
    question:
      "What's the difference between the Free plan and the Business / Pro plans?",
    answer:
      'The main differences between the plans include the number of projects you can create, what kind of privacy ' +
      'settings are available to you, and which formats you can publish or export your projects in. You can see a ' +
      'detailed list of each plan\'s features. You can see a detailed list of each plan\'s features <a href="/studio/pricing" title="Pricing">here</a>.'
  },
  {
    question: 'How do I switch plans?',
    answer:
      'You can upgrade or downgrade your plan anytime you’d like, from the “Subscription” tab in your account’s “Settings” page.'
  },
  {
    question: 'Can I cancel my Free plan?',
    answer:
      'If you’d like to leave us, you can cancel your account from the “Profile” tab in your account’s “Settings” page.'
  }
];

export type FaqItem = typeof faq;

export default faq;
